import { LoveMatchIcon, MatchTickIcon } from "assets/icons";
import Divider from "components/BaseWidgets/divider";
import Tag from "components/BaseWidgets/tag";
import "./style.scss";
import { retrieveToken } from "utils/storage";
import { normalizeText } from "utils/formatHelper";
import FemaleEmptyState from "assets/images/png/empty-female.png";
import MaleEmptyState from "assets/images/png/empty-male.png";
import { useProfileCompletion } from "hooks/api/useHome";

function ProfileMatch({ matchData = {}, id, image, isLock, preview }) {
  const matchPercentage = matchData?.match_percentage || 0;
  const tableData = matchData?.match_fields
    ? Object.entries(matchData.match_fields).map(([label, value]) => ({
        label,
        value,
      }))
    : [];
  const userData = JSON.parse(retrieveToken("user") || "{}");
  const { data: user } = useProfileCompletion();
  const gender = normalizeText(userData?.gender);
  const getDefaultImage = (opp = false) => {
    if (opp) {
      return gender === "male" ? FemaleEmptyState : MaleEmptyState;
    }

    return gender === "male" ? MaleEmptyState : FemaleEmptyState;
  };

  if (matchPercentage === 0) return;

  return (
    <div id={id} className={`profile-match-frame ${isLock && "locked-card"}`}>
      <div className="match-content flex flex-col gap-6">
        <div className="match-header flex flex-col gap-4">
          <div className="profile-img-frame">
            <div
              className="wrapper flex items-center justify-center"
              onContextMenu={(e) => {
                e.preventDefault();
                e.stopPropagation();
                alert("Saving images is disabled for privacy reasons.");
              }}
            >
              <span className="profile-img-container">
                <img
                  src={
                    user?.common_home_data?.user_image || getDefaultImage(false)
                  }
                  alt="Profile"
                  className="profile-img"
                />
              </span>
              <span className="profile-img-container">
                <img
                  src={
                    preview
                      ? getDefaultImage(true)
                      : image || getDefaultImage(true)
                  }
                  alt="Profile"
                  className="profile-img"
                />
              </span>
            </div>
            <span className="love-match-icon">
              <LoveMatchIcon />
            </span>
          </div>
          <div className="header-content flex flex-col justify-center items-center">
            <span className="font-title-normal">
              You and {gender === "male" ? "her" : "him"}
            </span>
            <Tag className="match-percentage" variant="yellow">
              {Math.round(matchPercentage)}% match
            </Tag>
            <p className="font-title-md fw-600 description">
              {gender === "male" ? "Her" : "His"} profile matches with{" "}
              {Math.round(matchPercentage)}% of your preferences
            </p>
          </div>
        </div>

        <div className="match-body">
          {tableData.map((item, index) => (
            <div key={index}>
              <div className="match-row flex justify-between items-center">
                <span className="table-label font-body-lg">{item.label}</span>
                <span className="table-value font-body-lg">{item.value}</span>
                <span>
                  <MatchTickIcon />
                </span>
              </div>
              {index !== tableData.length - 1 && (
                <Divider className="match-table" />
              )}
            </div>
          ))}
        </div>
        {matchData.match_text && (
          <div className="match-footer">
            <span className="default-match-data font-body-md fw-500">
              {matchData?.match_text}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileMatch;
